function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Layout = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native-web");
var _styles = require("./styles");
var _TopBar = require("../TopBar");
var _Shapes = require("../Shapes");
var _components = require("../../../../../components");
var _useLang = require("../useLang");
var _reactI18next = require("react-i18next");
var _native = require("@react-navigation/native");
var _locales = require("../../../../../locales");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["children", "style", "showBackButton", "showError", "hideTopBar", "showShapes"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var Layout = exports.Layout = (0, _react.memo)(function (_ref) {
  var children = _ref.children,
    style = _ref.style,
    showBackButton = _ref.showBackButton,
    _ref$showError = _ref.showError,
    showError = _ref$showError === void 0 ? false : _ref$showError,
    _ref$hideTopBar = _ref.hideTopBar,
    hideTopBar = _ref$hideTopBar === void 0 ? false : _ref$hideTopBar,
    _ref$showShapes = _ref.showShapes,
    showShapes = _ref$showShapes === void 0 ? false : _ref$showShapes,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  (0, _useLang.useSharedLang)();
  (0, _locales.useErrorLang)();
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _useStyles = (0, _styles.useStyles)(),
    styles = _useStyles.styles;
  var _isFocused = (0, _native.useIsFocused)();
  var _useState = (0, _react.useState)(true),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    _isScrollEnabled = _useState2[0],
    _setIsScrollEnabled = _useState2[1];
  var _onContentSizeChange = function _onContentSizeChange(_contentWidth, contentHeight) {
    if (_reactNative.Platform.OS !== 'web') {
      _setIsScrollEnabled(contentHeight > _reactNative.Dimensions.get('window').height);
    }
  };
  (0, _react.useEffect)(function () {
    if (!showError) return;
    (0, _components.ShowMessage)({
      text: t('error:default'),
      isCloseable: true
    });
  }, [showError, t]);
  if (!_isFocused) {
    return (0, _jsxRuntime.jsx)(_components.ActivityIndicator, {});
  }
  return (0, _jsxRuntime.jsxs)(_reactNative.KeyboardAvoidingView, Object.assign({
    behavior: _reactNative.Platform.OS === 'ios' ? 'padding' : undefined,
    style: [styles.container, style],
    testID: "Layout"
  }, props, {
    children: [showShapes && (0, _jsxRuntime.jsx)(_Shapes.Shapes, {}), (0, _jsxRuntime.jsxs)(_reactNative.ScrollView, {
      contentContainerStyle: styles.scrollContentContainer,
      keyboardShouldPersistTaps: "handled",
      keyboardDismissMode: "none",
      scrollEnabled: _isScrollEnabled,
      onContentSizeChange: _onContentSizeChange,
      children: [!hideTopBar && (0, _jsxRuntime.jsx)(_TopBar.TopBar, {
        style: styles.topBar,
        showBackButton: showBackButton
      }), _reactNative.Platform.OS === 'web' ? (0, _jsxRuntime.jsx)("main", {
        style: _reactNative.StyleSheet.flatten([styles.content]),
        id: "Content",
        tabIndex: -1,
        children: children
      }) : (0, _jsxRuntime.jsx)(_reactNative.View, {
        style: styles.content,
        children: children
      })]
    })]
  }));
});